import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Grid,
  Typography,
  Box,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Divider,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Chip,
} from "@mui/material";
import {
  Close as CloseIcon,
  ExpandMore as ExpandMoreIcon,
  Receipt as ReceiptIcon,
} from "@mui/icons-material";
import { Slide } from "@mui/material";
import axios from "axios";
import { API_URL } from "../../../config";
import { getCookie } from "../../../function";
import { NotificationManager } from "react-notifications";
import getArticleService from "../../../services/getArticleService";
import moment from "moment";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const RefundPaymentModal = ({ open, onClose, onSuccess, articleData }) => {
  const [formData, setFormData] = useState({
    accountNumber: "",
    ifscCode: "",
    bankName: "",
    beneficiaryName: "",
    refundReason: "",
    refundAmount: "",
  });

  const [loading, setLoading] = useState(false);
  const [openRefundProofDialog, setOpenRefundProofDialog] = useState(false);
  const [selectedRefundProof, setSelectedRefundProof] = useState(null);
  const [refundProofUrl, setRefundProofUrl] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Debug logs
  console.log("Article Data:", articleData);

  // Parse the article data to get payment and refund details
  const paymentHistory = articleData?.payments || [];
  const refundDetails = articleData?.refundDetails || [];

  console.log("Payment History:", paymentHistory);
  console.log("Refund Details:", refundDetails);

  const totalFees = parseFloat(articleData?.totalfees || 0);
  const feesRecived = parseFloat(articleData?.feesRecived || 0);
  const additionalFees = parseFloat(articleData?.additionalAmountReceived || 0);
  const remaningFees = parseFloat(articleData?.remaningFees || 0);

  const handleViewRefundProof = async (proofKey) => {
    try {
      const response = await getArticleService.getFilePreSIgnedUrl({
        key: proofKey,
      });
      setRefundProofUrl(response);
      setSelectedRefundProof(proofKey);
      setOpenRefundProofDialog(true);
    } catch (error) {
      console.error("Error fetching refund proof URL:", error);
      NotificationManager.error("Failed to load refund proof");
    }
  };

  const handleCloseRefundProofDialog = () => {
    setOpenRefundProofDialog(false);
    setSelectedRefundProof(null);
    setRefundProofUrl(null);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    if (name === "refundAmount") {
      const amount = parseFloat(value);
      if (amount > feesRecived) {
        NotificationManager.error("Refund amount cannot exceed fees received");
        return;
      }
      if (amount < 0) {
        NotificationManager.error("Refund amount cannot be negative");
        return;
      }
    }

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (
      !formData.accountNumber ||
      !formData.ifscCode ||
      !formData.bankName ||
      !formData.beneficiaryName ||
      !formData.refundReason ||
      !formData.refundAmount
    ) {
      NotificationManager.error("Please fill all required fields");
      return;
    }

    const refundAmount = parseFloat(formData.refundAmount);
    if (refundAmount > feesRecived) {
      NotificationManager.error("Refund amount cannot exceed fees received");
      return;
    }
    if (refundAmount < 0) {
      NotificationManager.error("Refund amount cannot be negative");
      return;
    }

    try {
      setLoading(true);
      const response = await axios.post(
        `${API_URL}/refund?id=${articleData.id}`,
        {
          accountNumber: formData.accountNumber,
          ifscCode: formData.ifscCode,
          bankName: formData.bankName,
          beneficiaryName: formData.beneficiaryName,
          refundReason: formData.refundReason,
          refundAmount: refundAmount,
          totalFees: totalFees,
          feesReceived: feesRecived,
          additionalFees: additionalFees,
          remainingFees: remaningFees,
        },
        {
          headers: {
            Authorization: getCookie("token"),
            "x-api-key": "JjgeTensKk20J7GIxBfMSaA25Aricvmr1HYmjxpS",
          },
        }
      );

      console.log("Response:", response.data);

      const data = response.data;
      console.log("Data:", data);
      const parsedData = JSON.parse(data);
      console.log("Parsed Data:", parsedData);
      const parsedBody = JSON.parse(parsedData.data.body);
      console.log("Parsed Body:", parsedBody);

      if (parsedBody) {
        console.log("Parsed Body:", parsedBody);

        if (parsedBody.success) {
          NotificationManager.success(
            parsedBody.message || "Refund processed successfully!"
          );
          // Clear form fields
          setFormData({
            accountNumber: "",
            ifscCode: "",
            bankName: "",
            beneficiaryName: "",
            refundReason: "",
            refundAmount: "",
          });
          onSuccess(formData);
          onClose();
        } else {
          NotificationManager.error(
            parsedBody.message || "Failed to process refund"
          );
        }
      } else {
        NotificationManager.error("Invalid response from server");
      }
    } catch (error) {
      console.error("Error processing refund:", error);
      let errorMessage = "An error occurred while processing refund";
      if (error.response?.data) {
        try {
          const errorData = error.response.data;
          if (errorData.data && errorData.data.body) {
            const errorBody = JSON.parse(errorData.data.body);
            errorMessage = errorBody.message || errorMessage;
          }
        } catch (e) {
          console.error("Error parsing error response:", e);
        }
      }
      NotificationManager.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      TransitionComponent={Transition}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6">Refund Payment</Typography>
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        {/* Fee Information Section */}
        <Box sx={{ mb: 4, mt: 2 }}>
          <Typography variant="subtitle1" gutterBottom>
            Fee Information
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={3}>
              <Typography variant="body2" color="text.secondary">
                Total Fees
              </Typography>
              <Typography variant="h6">{totalFees.toFixed(2)}</Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Typography variant="body2" color="text.secondary">
                Fees Received
              </Typography>
              <Typography variant="h6">{feesRecived.toFixed(2)}</Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Typography variant="body2" color="text.secondary">
                Additional Fees
              </Typography>
              <Typography variant="h6">{additionalFees.toFixed(2)}</Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Typography variant="body2" color="text.secondary">
                Remaining Fees
              </Typography>
              <Typography variant="h6">{remaningFees.toFixed(2)}</Typography>
            </Grid>
          </Grid>
        </Box>

        {/* Payment History Section */}
        <Box sx={{ mb: 4, mt: 4 }}>
          <Typography variant="subtitle1" gutterBottom>
            Payment History
          </Typography>
          <TableContainer component={Paper} sx={{ mb: 2 }}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Date</TableCell>
                  <TableCell>Amount</TableCell>
                  <TableCell>UTR No</TableCell>
                  <TableCell>Remark</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {paymentHistory && paymentHistory.length > 0 ? (
                  paymentHistory.map((payment, index) => (
                    <TableRow key={payment.paymentId || index}>
                      <TableCell>
                        {new Date(payment.paymentDate).toLocaleDateString()}
                      </TableCell>
                      <TableCell>{payment.amount}</TableCell>
                      <TableCell>{payment.utrNo || "N/A"}</TableCell>
                      <TableCell>{payment.remark || "N/A"}</TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={4} align="center">
                      No payment history available
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>

        {/* Refund History Section */}
        <Box sx={{ mb: 4 }}>
          <Typography variant="subtitle1" gutterBottom>
            Refund History
          </Typography>
          {refundDetails && refundDetails.length > 0 ? (
            refundDetails.map((refund, index) => (
              <Accordion key={refund.id || index} sx={{ mb: 2 }}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  sx={{
                    backgroundColor: "background.paper",
                    "&:hover": {
                      backgroundColor: "action.hover",
                    },
                  }}
                >
                  <Grid container alignItems="center" spacing={2}>
                    <Grid item xs={12} sm={3}>
                      <Typography variant="subtitle1">
                        Refund #{index + 1}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                      <Typography variant="subtitle1" color="error">
                        -{refund.refundAmount}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                      <Typography variant="body2" color="text.secondary">
                        {moment(refund.createdAt).format("MMMM D, YYYY")}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                      <Chip
                        label={refund.status}
                        sx={{
                          bgcolor: (() => {
                            switch (refund.status?.toLowerCase()) {
                              case "pending":
                                return "warning.main";
                              case "approved":
                                return "info.main";
                              case "rejected":
                                return "error.main";
                              case "completed":
                                return "success.main";
                              default:
                                return "grey.500";
                            }
                          })(),
                          color: "white"
                        }}
                        size="small"
                      />
                    </Grid>
                  </Grid>
                </AccordionSummary>
                <AccordionDetails>
                  <Paper
                    elevation={0}
                    sx={{ p: 2, bgcolor: "background.default" }}
                  >
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6}>
                        <Typography variant="body2" color="text.secondary">
                          Refund Amount: {refund.refundAmount}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Typography variant="body2" color="text.secondary">
                          Status: {refund.status}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Typography variant="body2" color="text.secondary">
                          Bank Name: {refund.bankName}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Typography variant="body2" color="text.secondary">
                          Account Number: {refund.accountNumber}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Typography variant="body2" color="text.secondary">
                          IFSC Code: {refund.ifscCode}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Typography variant="body2" color="text.secondary">
                          Beneficiary Name: {refund.beneficiaryName}
                        </Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <Typography variant="body2" color="text.secondary">
                          Reason: {refund.refundReason}
                        </Typography>
                      </Grid>
                      {refund.adminRemark && (
                        <Grid item xs={12}>
                          <Typography variant="body2" color="text.secondary">
                            Admin Remark: {refund.adminRemark}
                          </Typography>
                        </Grid>
                      )}
                      {refund.EditorRemark && (
                        <Grid item xs={12}>
                          <Typography variant="body2" color="text.secondary">
                            Editor Remark: {refund.EditorRemark}
                          </Typography>
                        </Grid>
                      )}
                      <Grid item xs={12}>
                        <Typography variant="body2" color="text.secondary">
                          Created At:{" "}
                          {moment(refund.createdAt).format(
                            "MMMM D, YYYY, h:mm A"
                          )}
                        </Typography>
                      </Grid>
                      {refund.RefundProofKey && (
                        <Grid item xs={12}>
                          <Button
                            variant="outlined"
                            startIcon={<ReceiptIcon />}
                            onClick={() =>
                              handleViewRefundProof(refund.RefundProofKey)
                            }
                            sx={{ mt: 1 }}
                          >
                            View Refund Proof
                          </Button>
                        </Grid>
                      )}
                    </Grid>
                  </Paper>
                </AccordionDetails>
              </Accordion>
            ))
          ) : (
            <Typography variant="body1" color="text.secondary" align="center">
              No refund history available
            </Typography>
          )}
        </Box>

        <Divider sx={{ my: 3 }} />

        {/* Refund Form Fields */}
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Account Number"
              name="accountNumber"
              value={formData.accountNumber}
              onChange={handleChange}
              required
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="IFSC Code"
              name="ifscCode"
              value={formData.ifscCode}
              onChange={handleChange}
              required
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Bank Name"
              name="bankName"
              value={formData.bankName}
              onChange={handleChange}
              required
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Beneficiary Name"
              name="beneficiaryName"
              value={formData.beneficiaryName}
              onChange={handleChange}
              required
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Refund Reason"
              name="refundReason"
              value={formData.refundReason}
              onChange={handleChange}
              multiline
              rows={3}
              required
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Refund Amount"
              name="refundAmount"
              value={formData.refundAmount}
              onChange={handleChange}
              type="number"
              required
              inputProps={{
                max: feesRecived,
                min: 0,
                step: "0.01"
              }}
              helperText={`Maximum refund amount: ${feesRecived.toFixed(2)}`}
              error={parseFloat(formData.refundAmount) > feesRecived}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions sx={{ p: 3 }}>
        <Button onClick={onClose} color="inherit">
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          color="primary"
          disabled={loading}
        >
          {loading ? "Processing..." : "Submit Refund"}
        </Button>
      </DialogActions>

      {/* Refund Proof Dialog */}
      <Dialog
        open={openRefundProofDialog}
        onClose={handleCloseRefundProofDialog}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
            boxShadow: "0px 0px 20px rgba(0, 0, 0, 0.15)",
          },
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: "1px solid",
            borderColor: "divider",
            p: 2,
          }}
        >
          Refund Payment Proof
          <IconButton
            aria-label="close"
            onClick={handleCloseRefundProofDialog}
            sx={{
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ p: 2, height: "80vh" }}>
          {selectedRefundProof && refundProofUrl && (
            <iframe
              src={refundProofUrl}
              style={{
                width: "100%",
                height: "100%",
                border: "none",
                borderRadius: 4,
              }}
              title="Refund Proof"
            />
          )}
        </DialogContent>
      </Dialog>
    </Dialog>
  );
};

export default RefundPaymentModal;
